<aside class="cm-nav" aria-label="Spaces">
  <div class="cm-brand" *ngIf="org_info">
    <img [src]="org_info" alt="Network logo" />
  </div>

  <div class="cm-search">
    <i class="fa fa-search" aria-hidden="true"></i>
    <label for="cm-space-search" class="cm-sr">Search spaces</label>
    <input id="cm-space-search" type="text" placeholder="Search spaces" [(ngModel)]="searchQuery"
      (keyup.enter)="CommunityChannelSearch()" (input)="onTypeSearch($event)" />
  </div>

  <app-filter-dropdown class="cm-filter" *ngIf="groupsList?.length && !isGroupScoped"
    icon="fa-users" [label]="groupsLabel" [allLabel]="'All ' + groupsLabel + 's'"
    [selectedLabel]="selectedGroupName" [options]="groupsList | filter: groupSearchText:'name'"
    [displayFn]="groupDisplayFn" [searchable]="true" searchPlaceholder="Search group..."
    [searchText]="groupSearchText" (searchTextChange)="groupSearchText = $event"
    (optionSelect)="selectGroup($event)">
  </app-filter-dropdown>

  <div class="cm-tabs" *ngIf="isTeamMember" role="tablist">
    <button role="tab" [class.on]="activeTab === 'public'" [attr.aria-selected]="activeTab === 'public'"
      (click)="switchTab('public')">Public</button>
    <button role="tab" [class.on]="activeTab === 'private'" [attr.aria-selected]="activeTab === 'private'"
      (click)="switchTab('private')">Private</button>
  </div>

  <nav class="cm-list">
    <button class="cm-add" *ngIf="activeTab !== 'private'" (click)="addChannel()">
      <i class="fa fa-plus" aria-hidden="true"></i> Add space
    </button>

    <ng-container *ngFor="let section of getVisibleSections()">
      <!-- same rule as the classic page: section headers show even when empty -->
      <section *ngIf="getSectionChannels(section)">
        <button class="cm-grp" (click)="toggleAccordion(section)" [attr.aria-expanded]="!!accordion[section]">
          {{ sectionLabel(section) }}
          <i class="fa" [ngClass]="accordion[section] ? 'fa-chevron-down' : 'fa-chevron-right'" aria-hidden="true"></i>
        </button>

        <ng-container *ngIf="accordion[section] && activeTab !== 'private'">
          <button *ngFor="let channel of visibleChannels(section); trackBy: trackChannel" class="cm-sp"
            [class.on]="isActive(channel)" [class.disabled]="channel.dataStatus === 'P'"
            [attr.aria-current]="isActive(channel) ? 'page' : null" (click)="open(channel)">
            <app-cm-space-row [name]="channel.channelName || channel.name" [avatarUrl]="avatarFor(channel)"
              [pending]="channel.dataStatus === 'P'"
              [unread]="section !== 'trending' ? unreadCount[channel?.channelUrl] : 0"
              [members]="section === 'trending' ? channel.members : 0"></app-cm-space-row>
          </button>
          <p class="cm-none" *ngIf="!visibleChannels(section).length">No spaces yet</p>
        </ng-container>

        <ng-container *ngIf="accordion[section] && activeTab === 'private'">
          <ng-container *ngFor="let team of getSectionChannels(section)">
            <button *ngIf="team.teamName !== 'Main' && team.teamId" class="cm-team" (click)="toggleTeamAccordion(team)"
              [attr.aria-expanded]="!!team.expanded">
              {{ team.teamName }}
              <i class="fa" [ngClass]="team.expanded ? 'fa-chevron-down' : 'fa-chevron-right'" aria-hidden="true"></i>
            </button>
            <ng-container *ngIf="team.expanded">
              <ng-container *ngFor="let channel of team.channels; trackBy: trackChannel">
                <button *ngIf="matchesTab(channel) && matchesSearch(channel)" class="cm-sp"
                  [class.indent]="team.teamName !== 'Main' && team.teamId" [class.on]="isActive(channel)"
                  [attr.aria-current]="isActive(channel) ? 'page' : null" (click)="open(channel, true)">
                  <app-cm-space-row [name]="channel.channelName || channel.name" [avatarUrl]="avatarFor(channel)"
                    [unread]="unreadCount[channel?.channelUrl]"></app-cm-space-row>
                </button>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </section>
    </ng-container>
  </nav>

  <div class="cm-foot">
    <button class="cm-back" (click)="headBackToNetwork()">
      <i class="fa fa-chevron-left" aria-hidden="true"></i> Head back to Network
    </button>
  </div>
</aside>
